<template>
  <div class="h-full w-full">
   
    <div class="flex flex-row flex-content-between items-center truncate pb-1 pl-2 pt-2">
      <div
      style="font-size: 15px;" 
        class=" bg-primary-500 text-primary-100 mr-1 rounded  p-1 mb-6"
      >
        C{{ socio.id }}
      </div>
      <div 
    class="flex items-start flex-col "
    :class="[true ? 'overflow-initial' : 'overflow-hidden']"
  >
      <p style="font-size: 16px;" class=" font-display pb-1 truncate max-w-full font-bold text-neutral-800">{{socio.nome_completo}}</p>
    <!-- <transition name="fade-left" appear>
      <span class="w-10 h-1 bg-primary-500 rounded"></span>
    </transition> -->
    </div>
      <div class="absolute top-0 right-0 pt-1 pr-1 " >

      <div
      v-if="socio.socio_administrador"
      style="border-radius: 20px; font-size: 8px;"
        class=" bg-neutral-700 text-primary-100 p-1  uppercase  flex-col  "
      >
        {{ socio.socio_administrador == 1 ? "Administrador" : "" }}
    </div>
    </div>
    </div>

    <div class="flex pb-1">
      <div class="pt-1  w-full border-neutral-300">
        <span class="pl-2 text-display text-1xl text-primary-600"
          >Dados Cadastrais</span
        >
        <div class="flex items-center ">
          <ul class="flex-grow pr-4" style="font-size: 15px;">
            <li class="py-3 flex items-center">
              <p class="text-neutral-700 pl-2 font-bold">
                Nome:
                <span class="font-normal text-neutral-800">{{
                  socio.nome_completo
                }}</span>
                <b-tooltip
                  label="copiado"
                  :active="copiado === socio.nome_completo"
                  always
                >
                  <button class="ml-2" @click="copyText(socio.nome_completo)">
                    <b-icon icon="content-copy" size="is-small"></b-icon>
                  </button>
                </b-tooltip>
              </p>
            </li>
            <li class="flex items-center">
              <p class="text-neutral-700 pl-2 font-bold">
                CPF:
                <span class="font-normal text-neutral-800">{{
                  socio.cpf
                }}</span>
                <b-tooltip
                  label="copiado"
                  :active="copiado === socio.cpf"
                  always
                >
                  <button class="ml-2" @click="copyText(socio.cpf)">
                    <b-icon icon="content-copy" size="is-small"></b-icon>
                  </button>
                </b-tooltip>
              </p>
            </li>
          </ul>
          <a href="#" @click.prevent="goToSocio(socio.id)" class="pr-3">
            <Icon-ArrowRight class="text-primary-600" />
          </a>
        </div>
        <div class=" w-full">
        <span class="text-display pl-2 text-1xl text-primary-600">Persona</span>
        <div class="flex-col ">
          <ul class="flex  " style="font-size: 12px;">
            <li class="py-3 flex items-center">
              <p class="text-neutral-700 pl-2 font-bold">
                Especialização:
                <span class="font-normal text-neutral-800">Lorem Ipsum</span>
              </p>
            </li>
            <li class="py-3 flex items-center">
              <p class="text-neutral-700 pl-2 font-bold">
                Instituição:
                <span class="font-normal text-neutral-800">UEM</span>
              </p>
            </li>
            <li class="py-3 flex items-center">
              <p class="text-neutral-700 pl-2 font-bold">
                Ano de Conlcusão:
                <span class="font-normal text-neutral-800">2014</span>
              </p>
            </li>
            <li class="flex items-center">
              <p class="text-neutral-700 pl-2 font-bold flex items-center">
                Trabalha como PF:
                <b-checkbox class="pl-4" />
              </p>
            </li>
          </ul>
        </div>
      </div>
      </div>
  
    </div>
  </div>
</template>

<script>
import bus from "@/services/bus";
import { clientesShowRequest } from "@/services/requests/clientes";
import { mapActions } from "vuex";

export default {
  name: "EmpresaShowSocios",
  props: ["socio"],
  data() {
    return {
      copiado: false,
    };
  },
  methods: {
    ...mapActions(["setCliente"]),
    goToSocio(id) {
      bus.globalLoading = true;
      clientesShowRequest(id)
        .then((res) => {
          this.setCliente(res.data.data);
          this.$router.push({ name: "clientes.show" });
        })
        .finally(() => (bus.globalLoading = false));
    },

    copyText(value) {
      this.$copyText(value);
      this.copiado = value;
      setTimeout(() => (this.copiado = false), 1500);
    },
  },
};
</script>
